import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.75715 16.9497L7.05004 16.2426L11.2927 12L7.05004 7.75736L7.75715 7.05025L11.9998 11.2929L16.2424 7.05025L16.9495 7.75736L12.7069 12L16.9495 16.2426L16.2424 16.9497L11.9998 12.7071L7.75715 16.9497Z",
      fill: "black"
    }, null, -1)
  ]))]))
}